import { Component, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MetricSelectorData, SelectedMetric } from 'src/app/reusables/metric-selector/metric-selector.model';
import { MetricSelectorService } from 'src/app/reusables/metric-selector/metric-selector.service';
import { reportingSetDefs } from 'src/app/reusables/reportingset-dynamic-filters-wrapper/mockReportingSetData';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerMetricInfo } from 'src/shared/models/module-manager/module-manager-settings.models';
import { FilterableField } from 'src/shared/models/pipeline-config/reporting-sets.models';
import { cloneDeep } from 'lodash';
import { MetricDynamicFiltersService } from './metric-dynamic-filters.service';

@Component({
    selector: 'cv-metric-dynamic-filters',
    templateUrl: './metric-dynamic-filters.component.html',
    styleUrl: './metric-dynamic-filters.component.scss'
})
export class MetricDynamicFiltersComponent {
    @Input() selectedMetrics: number[];
    @Input() moduleManager: ModuleManager;
    @Output() filterablesLoaded: EventEmitter<any> = new EventEmitter<any>();
    public filterableFields: { [FieldName: string]: FilterableField };

    constructor(private service: MetricDynamicFiltersService) {}

    async ngOnInit() {
        this.moduleManager.customSettingsAdded = true;
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedMetrics) {
            if (this.selectedMetrics?.length > 0) {
                this.filterableFields = await this.service.loadMetricFilterables(this.selectedMetrics);
                this.filterablesLoaded.emit(cloneDeep(this.filterableFields));
            }
            else {
                this.filterableFields = null;
            }
        }
    }
}
